import { Euler } from "three";
import { logger } from "../../../util/Logger";
import { RailExecutor } from "./RailExecutor";
import { RailGlassPart } from "./RailGlassPart";
import { RailPart } from "./RailPart";
import { RailPartOptions } from "./RailPartOptions";

const defaultRailPartOptions: RailPartOptions = {
  width: 1.2,
  height: 1.233,
  depth: 0.08,

  railSpacing: 0.1043,
  railOffset: 0.025,
  railWidth: 0.013,
  railHeight: 0.875,
  railDepth: 0.045,

  edgeWidth: 0.013,
  edgeHeight: 1.2,
  edgeDepth: 0.065,

  bottomHeight: 0.0229,
  bottomDepth: 0.055,
  bottomOffset: 0.303,

  topHeight: 0.03,
  topDepth: 0.08,

  baseWidth: 0.06,
  baseHeight: 0.015,
  baseDepth: 0.08,
  baseOffsetX: 0.0,
  baseOffsetY: 0.04,
  baseOffsetZ: 0.04,
  baseRotation: new Euler(Math.PI / 2, 0, 0),

  startOffset: 0.05,
  endOffset: 0.05,
  edgeOffset: 0.015,
  heightOffset: -0.2,
  depthOffset: -0.04,
};

export class SARAVAExecutor extends RailExecutor {
  constructor() {
    super(defaultRailPartOptions);
    logger.debug("SARAVAExecutor", this._options);
  }

  protected createRailPart(width: number): RailPart {
    return new RailGlassPart(width, this._options);
  }
}
